import clsx from "clsx";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks";
import { Layout } from "../../../ui/layout";
import { ButtonComponent } from "../../../ui/molecules/button/newButton";
import { Calendar } from "../../../ui/molecules/calendar";
import InputMultiSearch from "../../../ui/molecules/input/InputMultiSearch";
import { MadfarmInput } from "../../../ui/molecules/input/newInput";
import { MadfarmStaticSelect } from "../../../ui/molecules/select/newSelect/static";
import { MenuItems } from "../../../ui/organisms/navbar/dto";
import { Pagination } from "../../../ui/organisms/pagination";
import { departureMeansOptions, formatterDate, OptionType, sot, sotOrOfficeOptions, yearOptions } from "../../../utils";
import { GetCustomerByCompanyNameResponseDTO, getCustomersByIdResponseDTO } from "../../clienti/dto";
import { GetCustomersByCompanyName, GetCustomersById } from "../../clienti/slice";
import { DepartureListProtocol } from "./list";
import { GetAllDepartureProtocolAttachments, GetAllDepartureProtocolObjects, GetAllDepartureProtocols, resetDepartureProtocolCreationRequest, resetDepartureProtocolCreationStatus, resetGetAllDepartureProtocolAttachmentsStatus, resetGetAllDepartureProtocolObjectsStatus, resetGetAllPPFilters, setGetAllPPFilterAttachmentId, setGetAllPPFilterClient, setGetAllPPFilterdepartureMeans, setGetAllPPFilterFrom, setGetAllPPFilterHeadquarter, setGetAllPPFilterNumber, setGetAllPPFilterObjectId, setGetAllPPFilterObjectSpec, setGetAllPPFilterPage, setGetAllPPFilterSender, setGetAllPPFilterTo, setGetAllPPFilterYear } from "./slice";

type CustomerSearchItem = GetCustomerByCompanyNameResponseDTO | getCustomersByIdResponseDTO

export function DepartureProtocol() {
    const navigate = useNavigate()
    const dispatch = useAppDispatch()
    const departureProtocolState = useAppSelector(state => state.departureProtocol)
    const usersState = useAppSelector(state => state.users)
    const [attachments, setAttachments] = useState<OptionType[]>([])
    const [objects, setObjects] = useState<OptionType[]>([])
    const [filtersResetVersion, setFiltersResetVersion] = useState<number>(0)

    useEffect(() => {
        dispatch(GetAllDepartureProtocolObjects())
        dispatch(GetAllDepartureProtocolAttachments({
            itemsPerPage: 0,
            page: 0
        }))
    }, [])

    useEffect(() => {
        dispatch(resetDepartureProtocolCreationRequest())
        dispatch(resetDepartureProtocolCreationStatus())
    }, [])

    useEffect(() => {
        if (usersState.findMeStatus === 'successfully') {
            if (usersState.findMeResponse.headQuarterInfo?.code != 'SC' && usersState.findMeResponse.role !== 'admin') {
                dispatch(setGetAllPPFilterHeadquarter(usersState.findMeResponse.headQuarterInfo?.id))
            }
        }
    }, [usersState.findMeStatus])

    useEffect(() => {
        if (departureProtocolState.getAllDepartureProtocolAttachmentsStatus === 'successfully' &&
            departureProtocolState.getAllDepartureProtocolAttachmentsResponse !== undefined
        ) {
            dispatch(resetGetAllDepartureProtocolAttachmentsStatus())
            const data = departureProtocolState.getAllDepartureProtocolAttachmentsResponse
            const newAtts: OptionType[] = data.data.map(d => {
                return { value: d.id, label: `${d.description} [${d.coding}]` } as OptionType
            })
            setAttachments(newAtts)
        }
    }, [departureProtocolState.getAllDepartureProtocolAttachmentsStatus])

    useEffect(() => {
        if (departureProtocolState.getAllDepartureProtocolObjectsStatus === 'successfully' &&
            departureProtocolState.getAllDepartureProtocolObjectsResponse !== undefined
        ) {
            dispatch(resetGetAllDepartureProtocolObjectsStatus())
            const data = departureProtocolState.getAllDepartureProtocolObjectsResponse
            const newObjects: OptionType[] = data.map(d => {
                return { value: d.id, label: `${d.description} [${d.coding}]` } as OptionType
            })
            setObjects(newObjects)
        }
    }, [departureProtocolState.getAllDepartureProtocolObjectsStatus])

    const searchCustomers = async (query: string): Promise<CustomerSearchItem[]> => {
        const response = await dispatch(GetCustomersByCompanyName(query)).unwrap()
        return (response?.data ?? []) as CustomerSearchItem[]
    }

    const searchLeadCustomers = async (query: string): Promise<CustomerSearchItem[]> => {
        const response = await dispatch(GetCustomersByCompanyName({
            search: query,
            operatorsGroup: 'CAPOFILA'
        })).unwrap()
        return (response?.data ?? []) as CustomerSearchItem[]
    }

    const fetchCustomerById = async (id: string): Promise<CustomerSearchItem> => {
        const response = await dispatch(GetCustomersById(id)).unwrap()
        return response as CustomerSearchItem
    }

    return (
        <Layout
            menuItem={MenuItems.PROTOCOLLO}
            breadcrumbItems={['Gestione Protocollo', 'Protocollo Partenza']}
            noPaddingLat
            headerLabel="Protocollo Partenza"
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end">
                    <ButtonComponent
                        size={"sm"}
                        iconPosition={"off"}
                        variant={"solid"}
                        label="Aggiungi Protocollo Partenza"
                        color={"orange"}
                        onClick={() => {
                            navigate('/addDepartureProtocol')
                        }}
                    />
                </div>
            }
        >
            <div className="w-[100%] flex flex-col gap-[16px] filter" style={{ padding: '24px 24px 0px 24px' }}>
                <div className={"grid grid-cols-3 gap-4"}>
                    <MadfarmStaticSelect
                        key={departureProtocolState.getAllDepartureProtocolFilters.headquarter || 'typology-select'}
                        label="Tipologia"
                        isClearable
                        noOptionsMessage={"Nessun risultato trovato"}
                        placeholder={'Sede / Ufficio'}
                        options={sotOrOfficeOptions}
                        disabled={usersState.findMeResponse.headQuarterInfo?.code != 'SC' && usersState.findMeResponse.role !== 'admin'}
                        value={departureProtocolState.getAllDepartureProtocolFilters.headquarter}
                        defaultValue={departureProtocolState.getAllDepartureProtocolFilters.headquarter}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value ? value.value : null
                            dispatch(setGetAllPPFilterHeadquarter(newValue))
                        }}
                    />
                    <MadfarmInput
                        label={'Numero'}
                        placeholder="Specifica Numero"
                        value={departureProtocolState.getAllDepartureProtocolFilters.number}
                        onChangeText={(text) => { dispatch(setGetAllPPFilterNumber(text)) }}
                    />
                    <MadfarmStaticSelect
                        label="Anno"
                        isClearable
                        placeholder={'Anno'}
                        options={yearOptions}
                        key={departureProtocolState.getAllDepartureProtocolFilters.year || 'default'}
                        value={departureProtocolState.getAllDepartureProtocolFilters.year}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value ? value.value : null
                            dispatch(setGetAllPPFilterYear(newValue))
                        }}
                        noOptionsMessage={"Nessun risultato trovato"}
                    />
                </div>
                <div className={"grid grid-cols-3 gap-4"}>
                    <MadfarmStaticSelect
                        isClearable
                        label={"Mezzo di Entrata"}
                        placeholder={'Seleziona'}
                        options={departureMeansOptions}
                        key={departureProtocolState.getAllDepartureProtocolFilters.departureMeans || 'default'}
                        value={departureProtocolState.getAllDepartureProtocolFilters.departureMeans}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value ? value.value : null
                            dispatch(setGetAllPPFilterdepartureMeans(newValue))
                        }}
                        noOptionsMessage={"Nessun risultato trovato"}
                    />
                    <Calendar
                        label="Dal"
                        onClear={(date) => dispatch(setGetAllPPFilterFrom(date))}
                        selected={departureProtocolState.getAllDepartureProtocolFilters.from}
                        onChange={(date) => dispatch(setGetAllPPFilterFrom(date))}
                    />
                    <Calendar
                        label="Al"
                        onClear={(date) => dispatch(setGetAllPPFilterFrom(date))}
                        selected={departureProtocolState.getAllDepartureProtocolFilters.to}
                        onChange={(date) => dispatch(setGetAllPPFilterTo(date))}
                    />
                </div>
                <div className={"grid grid-cols-3 gap-4 items-start"}>
                    <InputMultiSearch
                        key={`client-${filtersResetVersion}`}
                        searchOne
                        label={'Cliente'}
                        placeholder="Ragione sociale"
                        onSearch={searchCustomers}
                        onFetchById={fetchCustomerById}
                        getId={(customer) => customer.id}
                        renderResult={(customer, isSelected) => {
                            const isInactive = customer.endingDate !== null
                            return (
                                <div className="flex flex-col gap-0.5 items-start">
                                    <span
                                        className={clsx('font-semibold text-left', {
                                            'text-red-600': isInactive && !isSelected,
                                            'text-brandPrimary-700': !isInactive && !isSelected,
                                        })}
                                    >
                                        {customer.companyName}
                                    </span>
                                    <span className="text-xs text-neutral-600 text-left">
                                        {customer.countryRegion} - {customer.cuaa} - {customer.clientCode}
                                    </span>
                                    <span className="text-xs text-neutral-500 text-left">
                                        Data In: {formatterDate(customer.startingDate)} | Data Out: {customer.endingDate ? formatterDate(customer.endingDate) : '-'}
                                    </span>
                                </div>
                            )
                        }}
                        renderSelected={(customer) => (
                            <div className="flex flex-col gap-0.5 flex-1 items-start">
                                <span className="text-sm font-bold text-brandPrimary-700 text-left">
                                    {customer.companyName}
                                </span>
                                <span className="text-xs text-brandPrimary-600 text-left">
                                    {customer.countryRegion} - {customer.cuaa} - {customer.clientCode}
                                </span>
                                <span className="text-xs text-brandPrimary-600 text-left">
                                    Data In: {formatterDate(customer.startingDate)} | Data Out: {customer.endingDate ? formatterDate(customer.endingDate) : '-'}
                                </span>
                            </div>
                        )}
                        defaultIds={departureProtocolState.getAllDepartureProtocolFilters.client ? [departureProtocolState.getAllDepartureProtocolFilters.client] : []}
                        onSelectAddHandler={(res) => {
                            dispatch(setGetAllPPFilterClient(res[0] ?? ''))
                        }}
                    />
                    <InputMultiSearch
                        key={`receiver-${filtersResetVersion}`}
                        searchOne
                        label={'Destinatario'}
                        placeholder="Ragione sociale"
                        onSearch={searchLeadCustomers}
                        onFetchById={fetchCustomerById}
                        getId={(customer) => customer.id}
                        renderResult={(customer, isSelected) => {
                            const isInactive = customer.endingDate !== null
                            return (
                                <div className="flex flex-col gap-0.5 items-start">
                                    <span
                                        className={clsx('font-semibold text-left', {
                                            'text-red-600': isInactive && !isSelected,
                                            'text-brandPrimary-700': !isInactive && !isSelected,
                                        })}
                                    >
                                        {customer.companyName}
                                    </span>
                                    <span className="text-xs text-neutral-600 text-left">
                                        {customer.countryRegion} - {customer.cuaa} - {customer.clientCode}
                                    </span>
                                    <span className="text-xs text-neutral-500 text-left">
                                        Data In: {formatterDate(customer.startingDate)} | Data Out: {customer.endingDate ? formatterDate(customer.endingDate) : '-'}
                                    </span>
                                </div>
                            )
                        }}
                        renderSelected={(customer) => (
                            <div className="flex flex-col gap-0.5 flex-1 items-start">
                                <span className="text-sm font-bold text-brandPrimary-700 text-left">
                                    {customer.companyName}
                                </span>
                                <span className="text-xs text-brandPrimary-600 text-left">
                                    {customer.countryRegion} - {customer.cuaa} - {customer.clientCode}
                                </span>
                                <span className="text-xs text-brandPrimary-600 text-left">
                                    Data In: {formatterDate(customer.startingDate)} | Data Out: {customer.endingDate ? formatterDate(customer.endingDate) : '-'}
                                </span>
                            </div>
                        )}
                        onSelectAddHandler={(res) => {
                            if ((res?.length ?? 0) === 0) {
                                dispatch(setGetAllPPFilterSender(''))
                                return
                            }

                            void fetchCustomerById(res[0])
                                .then((customer) => {
                                    dispatch(setGetAllPPFilterSender(customer.companyName))
                                })
                                .catch(() => {
                                    dispatch(setGetAllPPFilterSender(''))
                                })
                        }}
                    />
                    <MadfarmStaticSelect
                        isClearable
                        label={"Allegato"}
                        placeholder={'Seleziona allegato'}
                        options={attachments}
                        key={departureProtocolState.getAllDepartureProtocolFilters.attachmentId || 'default'}
                        value={departureProtocolState.getAllDepartureProtocolFilters.attachmentId}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value ? value.value : null
                            dispatch(setGetAllPPFilterAttachmentId(newValue))
                        }}
                        noOptionsMessage={"Nessun risultato trovato"}
                    />
                </div>
                <div className={"grid grid-cols-2 gap-4"}>
                    <MadfarmStaticSelect
                        isClearable
                        label={"Oggetto"}
                        placeholder={'Seleziona Oggetto'}
                        options={objects}
                        key={departureProtocolState.getAllDepartureProtocolFilters.objectId || 'default'}
                        value={departureProtocolState.getAllDepartureProtocolFilters.objectId}
                        onChange={(value) => {
                            //@ts-ignore
                            const newValue = value ? value.value : null
                            dispatch(setGetAllPPFilterObjectId(newValue))
                        }}
                        noOptionsMessage={"Nessun risultato trovato"}
                    />
                    <MadfarmInput
                        label={'Specifiche Oggetto'}
                        placeholder="Specifiche"
                        value={departureProtocolState.getAllDepartureProtocolFilters.objectSpec}
                        onChangeText={(text) => { dispatch(setGetAllPPFilterObjectSpec(text)) }}
                    />
                </div>
                <div className={"flex flex-row gap-1 items-center justify-end"}>
                    <ButtonComponent
                        size={"sm"}
                        iconPosition={"off"}
                        variant={"outline"}
                        label="Pulisci"
                        color={"gray"}
                        onClick={() => {
                            dispatch(resetGetAllPPFilters())
                            setFiltersResetVersion((prev) => prev + 1)
                            dispatch(GetAllDepartureProtocols({
                                number: '',
                                client: '',
                                receiver: '',
                                attachmentId: '',
                                objectId: '',
                                objectSpec: '',
                                itemsPerPage: '50',
                                page: 0,
                                sort: "protocolDate",
                                order: false,
                                headquarter: ""
                            }))
                        }}
                    />
                    <ButtonComponent
                        variant='solid'
                        color='orange'
                        size='sm'
                        iconPosition='off'
                        label='Cerca'
                        onClick={() => dispatch(GetAllDepartureProtocols(departureProtocolState.getAllDepartureProtocolFilters))}
                    />
                </div>
            </div>
            <Pagination
                numbResults={departureProtocolState.getAllDepartureProtocolsResponse ? departureProtocolState.getAllDepartureProtocolsResponse?.data?.length : 0}
                detailsResults={'Protocolli'}
                fullWidth={true}
                pages={departureProtocolState.getAllDepartureProtocolsResponse?.totalPage || 1}
                currentPage={departureProtocolState.getAllDepartureProtocolFilters.page ? departureProtocolState.getAllDepartureProtocolFilters.page : 0}
                setPage={(page) => dispatch(setGetAllPPFilterPage(page))}
            />
            <DepartureListProtocol />
        </Layout>
    )
}